export default __webpack_public_path__ + "static/pair-icon-light-74c9c1c0906cc5ce3d70769b7eaf4c791ba3084f1ea0a2c633fdfd339fcc1b76.png";